<div class="slider-item loader">
  <!-- <div class="slider-img" [attr.vidoe-slug]="video.slug" lazy-load-images (click)="videoClick(video);"> -->

  <div class="slider-img" lazy-load-images>
    <img alt="video.title" src="assets/images/defaultloader.png">
  </div>
  <div class="slider-content shimmer">
      <h3>
      </h3>
  </div>
</div>
